import { useEffect } from 'react'

const useOnUnountEffect = (fn) => {
  useEffect(() => fn, []) // eslint-disable-line
}

export default useOnUnountEffect
